import { createFileRoute, redirect } from '@tanstack/react-router'

// The WhatsApp AI agent config now lives as a section inside campaign Settings.
// Keep this path as a redirect so any existing links land in the right place.
export const Route = createFileRoute('/_auth/company/$companyId/$campaignId/whatsapp-ai')({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: '/company/$companyId/$campaignId/settings/whatsapp-ai',
			params,
		})
	},
})
